/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */
import axios from 'axios';
import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class PreferencesRequest extends MainRequest{
    static savePreferences(data, token) {
        return this.postSEC(ServicePath.SAVE_PREFERENCES, data);
    }
}